<template>
    <div class="c-buttons tipo-planta">
        <type-button src-icon="/img/iconos/icon_ecologico.svg" @click="$emit('input', true)" :active="value === true">
            Ecológica
        </type-button>
        <type-button no-icon @click="$emit('input', false)" :active="value === false">
            Residuo Cero
            <template v-slot:info>
                <img v-b-modal.modal-residuocero src="/img/iconos/icon_info_nm.svg" alt="icon_info_nm.svg" class="icon-info">
                <modal-block v-cloak title="Residuo Cero" :href="route('help.details','residuo-cero')" desing="residuocero" refer="residuocero">
                    Planta para producción convencional cultivada con productos químicos de bajo impacto.
                </modal-block>
            </template>
        </type-button>
    </div>
</template>

<script>
    import TypeButton from "./TypeButton";
    export default {
        name: "EcoTypeButtons",
        components: {TypeButton},
        props: {
            value: {
                type: Boolean,
                default: null
            }
        }
    }
</script>

<style scoped>
    .c-buttons {
        display: flex;
        justify-content: space-between;
        align-items: stretch;
        flex-wrap: wrap;
        margin: -0.5em 0 0 -0.5em;
        width: calc(100% + 0.5em);
    }

    .c-buttons > * {
        margin: 0.5em 0 0 0.5em;
        flex: 1 0 0;
    }

    @media (min-width: 575px) {

        .c-buttons {
            margin: -1.25em 0 0 -1.25em;
            width: calc(100% + 1.25em);
        }

        .c-buttons > * {
            margin: 1.25em 0 0 1.25em;
        }

    }

</style>
